import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudVisitaActivoService {
  private apiUrl = `${environment.apiUrl}/solicitud-visita-activo`;

  constructor(private http: HttpClient) {}

  getActivosAsignados(solicitudId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${solicitudId}`);
  }

  asignarActivos(solicitudId: number, activoIds: number[]): Observable<any> {
    return this.http.post(`${this.apiUrl}/${solicitudId}`, { activoIds });
  }

  removeActivosAsignados(solicitudId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${solicitudId}`);
  }
}
